import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { WeeklyScheduleWidget } from '../weekly-schedule/WeeklyScheduleWidget'

/**
 * <holdstyring-week-grid> Web Component
 *
 * The studio's 7-column weekday ugekalender (Mon..Sun columns), with a day-filter
 * bar and week navigation. This is the same renderer as
 * <holdstyring-weekly-schedule layout="grid">, exposed as its own element so a
 * page can drop in the grid without remembering the attribute.
 *
 * Attributes:
 *   api-key: Required.
 *   tenant-slug: Required on external sites (or base-url for a custom domain).
 *   hold-type-slugs="yoga,pilates": Optional. Only these hold-mærkater.
 *   title="Ugeplan": Optional heading above the grid.
 *   week-nav="false": Optional. Hide the previous/next-week arrows.
 *   theme-*: Optional. See HoldstyringWidgetBase.observedAttributes.
 */
class HoldstyringWeekGridElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return WeeklyScheduleWidget
  }

  protected getWidgetProps() {
    const slugsRaw = this.getAttribute('hold-type-slugs') || ''
    const holdTypeSlugs = slugsRaw.split(',').map(s => s.trim()).filter(Boolean)
    return {
      holdTypeSlugs,
      title: this.getAttribute('title') || null,
      weekNav: this.getAttribute('week-nav') !== 'false',
      layout: 'grid' as const,
      // guests-only="true": gæste-fokuseret booking (stepperen vises åben).
      guestsOnly: this.getAttribute('guests-only') === 'true',
    }
  }
}

if (!customElements.get('holdstyring-week-grid')) {
  customElements.define('holdstyring-week-grid', HoldstyringWeekGridElement)
}

export { HoldstyringWeekGridElement }
